/* unplugin-vue-components disabled */import script from "./sex.vue?vue&type=script&lang=ts&setup=true"
export * from "./sex.vue?vue&type=script&lang=ts&setup=true"

export default script